import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift, Lock, Sparkles, Wallet, Zap } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRICE_LABEL, PRIMARY_CTA, packageIncludes } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
export function PricingSection() {
  const firstBonusIndex = packageIncludes.findIndex(item => item.kind === 'bonus');
  const firstExtraIndex = packageIncludes.findIndex(item => item.kind === 'extra');
  return <section id="pricing" className="py-20 px-4 bg-[#F2F7F8] relative" data-id="element-217" data-mp="1s7sl0hgc5sx2">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-218" data-mp="1x9rpxvrq4xw4">
        <div className="text-center mb-10" data-id="element-219" data-mp="227t5w7tush3d">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-3 text-[#0F4C5C] uppercase" data-id="element-220" data-mp="226i42djyxjew">
            Your Complete <span className="text-[#0B7A7A]" data-id="element-221" data-mp="2wa1m6jhvx01">Dental Instructor Atlas</span> Package
          </h2>
          <p className="text-slate-700/80 text-sm md:text-base" data-id="element-222" data-mp="7ubq56zowoiw">
            Everything You Need to Plan, Explain, Demonstrate &amp; Assess Your Students More Effectively
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-[#D6E7EA] border-2 border-[#0F4C5C] rounded-3xl p-1 relative shadow-xl shadow-[#0F4C5C]/10" data-id="element-223" data-mp="1hodhefuew1vh">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#0B7A7A] text-white font-bold px-5 py-1.5 rounded-full shadow uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap z-10" data-id="element-224" data-mp="20gfyfsaytk69">
            <Sparkles size={14} data-id="element-225" data-mp="1rgatdot8uxv9" /> Complete Package
          </div>
          <div className="bg-white rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-226" data-mp="1ri3z91w19e27">
            <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="w-full max-w-md h-auto mx-auto mb-6" loading="lazy" data-id="element-227" data-mp="k3ircut0671k" />

            <p className="text-sm font-bold tracking-widest text-[#0A6464] mb-3" data-id="element-228" data-mp="hib1fnlu49oi">YOU RECEIVE</p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-[#F2F7F8] border border-slate-200 rounded-xl p-4" data-id="element-229" data-mp="mgciy43m40xv">
              <li className="text-xs font-bold tracking-widest text-[#0A6464]" data-id="element-230" data-mp="7lofswlopelf">
                THE COMPLETE 6-IN-1 VISUAL DENTAL TRAINING SYSTEM
              </li>
              {packageIncludes.map((item, itemIndex) => <React.Fragment key={item.label} data-id="element-231" data-mp="3hqhgo46o7tf" data-mpi={itemIndex}>
                  {itemIndex === firstBonusIndex && <li className="pt-2 text-xs font-bold tracking-widest text-[#0A6464]" data-id="element-232" data-mp="3kyqehc15yu3q">
                      PLUS 5 EXCLUSIVE BONUSES
                    </li>}
                  {itemIndex === firstExtraIndex && <li className="pt-2 border-t border-slate-200" aria-hidden="true" data-id="element-233" data-mp="3bz3i54nakehj" />}
                  <li className={`flex items-start gap-2 text-sm ${item.kind === 'extra' ? 'font-bold uppercase tracking-wide text-[#0F4C5C]' : 'text-slate-700'}`} data-id="element-234" data-mp="3fyvtfp42kyql">
                    {item.kind === 'bonus' ? <Gift size={16} className="text-[#0B7A7A] shrink-0 mt-0.5" data-id="element-235" data-mp="31cye81xyswv6" /> : <Check size={16} className="text-[#0B7A7A] shrink-0 mt-0.5" data-id="element-236" data-mp="3g9fn8miolzek" />}
                    <span data-id="element-237" data-mp="3bbe3dzdflw21">{item.label}</span>
                  </li>
                </React.Fragment>)}
            </ul>

            <div className="mb-6" data-id="element-238" data-mp="3p1regalmdqvl">
              <div className="flex flex-wrap items-baseline justify-center gap-2" data-id="element-239" data-mp="3p43wenrdo18n">
                <span className="text-2xl md:text-3xl text-[#0F4C5C] font-semibold" data-id="element-240" data-mp="3l2saotbmk05q">YOUR PRICE:</span>
                <span className="text-4xl md:text-5xl font-extrabold tracking-tight text-[#0B7A7A]" data-id="element-241" data-mp="2sykdzb2gv9m">
                  {PRICE_LABEL}
                </span>
              </div>
            </div>

            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-242" data-mp="hvzywno5gnzr">
              {PRIMARY_CTA}
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-slate-500" data-id="element-243" data-mp="vq0oaqt7oyng">
              <span className="flex items-center gap-1.5" data-id="element-244" data-mp="3v54c4atkwzv0">
                <Lock size={12} className="text-[#0B7A7A]" data-id="element-245" data-mp="3v6p9073d8uw1" /> Secure Payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-246" data-mp="32wf09n35y5v">
                <Zap size={12} className="text-[#0B7A7A]" data-id="element-247" data-mp="7yva0g2x6ef9" /> Immediate Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-248" data-mp="cz9gvussbibp">
                <Wallet size={12} className="text-[#0B7A7A]" data-id="element-249" data-mp="1jf226tktd204" /> One-Time Payment
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}